import coreAPIInstance from "./coreApiInstance";

export const notificationAPIs = {
  getNotifications: ({ payload, entityId }) =>
    coreAPIInstance.get(`/api/v1/notifications/entityId/${entityId}`, payload),
};
